import React from 'react';
import Navbar from '../../components/navbar';
import InfoDashboard from '../../components2/infoDashboard';

function Dashboard () {
    return (
        <InfoDashboard />
    )
}

export default Dashboard;